import React from 'react';

/**
 * PaymentGrid — offizielle Marken-Logos (SVG-Assets unter /public/payment/)
 * in einheitlichen, sauberen weißen Tiles.
 */

const IMG_LOGOS = {
  visa: { src: '/payment/visa.svg', pad: 'p-2.5' },
  mastercard: { src: '/payment/mastercard.svg', pad: 'p-1.5' },
  amex: { src: '/payment/amex.svg', pad: 'p-2' },
  paypal: { src: '/payment/paypal.svg', pad: 'p-2.5' },
  apple: { src: '/payment/applepay.svg', pad: 'p-2.5' },
  gpay: { src: '/payment/googlepay.svg', pad: 'p-2' },
  klarna: { src: '/payment/klarna.svg', pad: 'p-0' },
};

export const ALL_PAYMENTS = [
  { code: 'visa', label: 'Visa' },
  { code: 'mastercard', label: 'Mastercard' },
  { code: 'amex', label: 'American Express' },
  { code: 'paypal', label: 'PayPal' },
  { code: 'apple', label: 'Apple Pay' },
  { code: 'gpay', label: 'Google Pay' },
  { code: 'klarna', label: 'Klarna' },
  { code: 'sofort', label: 'Sofortüberweisung' },
  { code: 'sepa', label: 'SEPA-Lastschrift' },
];

function LogoContent({ code, label, small = false }) {
  const txt = small ? 'text-[10px]' : 'text-[13px]';
  if (code === 'sepa') return <span className={`${txt} font-bold tracking-wide select-none text-[#10298e]`}>SEPA</span>;
  if (code === 'sofort') return <span className={`${txt} font-bold tracking-wide select-none text-[#eb6f93]`}>SOFORT</span>;
  const l = IMG_LOGOS[code];
  return (
    <img
      src={l.src}
      alt={label}
      loading="lazy"
      className={`max-h-full max-w-full object-contain ${l.pad}`}
      draggable={false}
    />
  );
}

export function PaymentBadge({ code }) {
  const p = ALL_PAYMENTS.find((x) => x.code === code);
  return (
    <div className="h-10 rounded-lg overflow-hidden bg-white border border-stone-200 flex items-center justify-center">
      <LogoContent code={code} label={p?.label || code} />
    </div>
  );
}

export default function PaymentGrid({ cols = 3, small = false }) {
  if (cols >= 7) {
    return (
      <div className="flex flex-wrap justify-center gap-2" data-testid="payment-grid">
        {ALL_PAYMENTS.map((p) => (
          <div
            key={p.code}
            className="h-9 w-[74px] rounded-lg overflow-hidden bg-white border border-stone-200 shadow-[0_1px_2px_rgba(0,0,0,0.04)] hover:border-stone-300 transition-colors flex items-center justify-center px-1.5"
            data-testid={`payment-${p.code}`}
            title={p.label}
          >
            <LogoContent code={p.code} label={p.label} small />
          </div>
        ))}
      </div>
    );
  }
  const height = small ? 'h-9' : 'h-11';
  const gridClass = cols === 5 ? 'grid-cols-5 gap-1.5' : cols === 4 ? 'grid-cols-4 gap-2' : 'grid-cols-3 gap-2.5';
  return (
    <div className={`grid ${gridClass}`} data-testid="payment-grid">
      {ALL_PAYMENTS.map((p) => (
        <div
          key={p.code}
          className={`${height} rounded-lg overflow-hidden bg-white border border-stone-200 shadow-[0_1px_2px_rgba(0,0,0,0.04)] hover:border-stone-300 transition-colors flex items-center justify-center px-1`}
          data-testid={`payment-${p.code}`}
          title={p.label}
        >
          <LogoContent code={p.code} label={p.label} small={small} />
        </div>
      ))}
    </div>
  );
}
